// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_SHOW_SCREEN } from "./constants"

export function showScreen(screen, more = {}) {
  return {
    type: DAMAGE_CASE_SHOW_SCREEN,
    data: { screen, ...more },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_SHOW_SCREEN:
      return {
        ...state,
        ...action.data,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/showScreen.js